import api from './api';

// Get all categories for a timeline
const getCategories = async (timelineId) => {
  const response = await api.get(`/api/timelines/${timelineId}/categories`);
  return response.data;
};

// Create a new category
const createCategory = async (timelineId, categoryData) => {
  const response = await api.post(`/api/timelines/${timelineId}/categories`, categoryData);
  return response.data;
};

// Update a category
const updateCategory = async (categoryId, categoryData) => {
  const response = await api.put(`/api/categories/${categoryId}`, categoryData);
  return response.data;
};

// Delete a category
const deleteCategory = async (categoryId) => {
  const response = await api.delete(`/api/categories/${categoryId}`);
  return response.data;
};

const categoryService = {
  getCategories,
  createCategory,
  updateCategory,
  deleteCategory,
};

export default categoryService; 